// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessions-page .filter-bar {
  display: flex;
  justify-content: space-between;
  background-color: #002856;
  width: 100%;
  min-height: 2em; }
  .sessions-page .filter-bar .schedule-filter {
    display: flex;
    align-items: center;
    color: white; }
    .sessions-page .filter-bar .schedule-filter label {
      margin: 5px; }
  .sessions-page .filter-bar .custom-filter {
    display: flex;
    align-items: center;
    color: white;
    margin: 5px;
    cursor: pointer; }

.sessions-page .session-link {
  width: calc(100% - 100px); }
  .sessions-page .session-link:hover {
    text-decoration: none; }

.sessions-page .session-icons {
  margin: .5em;
  position: absolute;
  right: 0;
  top: 0;
  color: #606060; }
  .sessions-page .session-icons ul li {
    list-style-type: none; }

.sessions-page .session {
  color: black;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative; }

.sessions-page .session:not(.no-hover):hover {
  background: #d4e4e9; }

.sessions-page .session-time {
  background: #909092;
  color: white;
  padding: 10px; }

.sessions-page .session-reg {
  text-align: center;
  width: 90px; }
  .sessions-page .session-reg .fa {
    margin-top: .1em;
    font-size: 2.25em; }
    .sessions-page .session-reg .fa.fa-plus-circle {
      color: gray; }
    .sessions-page .session-reg .fa.fa-check-circle {
      color: #4330ff; }
      .sessions-page .session-reg .fa.fa-check-circle.yellow {
        color: #feb52b; }
      .sessions-page .session-reg .fa.fa-check-circle.grey {
        color: grey; }

.sessions-page .p2p-reg {
  color: gray;
  border: 0px solid #eaeaea;
  text-align: center;
  width: 90px;
  line-height: 1.2;
  padding-top: 10px;
  background-color: white; }

.sessions-page .track-color {
  display: inline;
  padding: 1px;
  float: left;
  width: .25em;
  min-height: 4.5em;
  margin-right: .35em; }

.sessions-page .session-reg {
  border: 0.5px solid #eaeaea;
  border-right: none;
  background: #f2f2f2;
  padding-right: 0px !important; }
  .sessions-page .session-reg p {
    margin: 5px 0px 0px -3px;
    text-align: center; }

.sessions-page .session-name {
  padding-top: 10px;
  color: black;
  line-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block; }

.sessions-page .session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px; }

.sessions-page .session.itinerary {
  padding: 20px; }
  .sessions-page .session.itinerary .session-name {
    color: #909092; }
  .sessions-page .session.itinerary:hover {
    cursor: default;
    background: none; }

.sessions-page .blue {
  color: #4330ff; }

.sessions-page .carousel {
  min-height: 67px; }

.sessions-page .disabled {
  opacity: 0.3; }

@media only screen and (min-width: 575px) {
  .sessions-page .carousel {
    min-height: 99px; } }

@media only screen and (min-width: 767px) {
  .sessions-page .carousel {
    min-height: 134px; } }

@media only screen and (min-width: 991px) {
  .sessions-page .carousel {
    min-height: 181px; } }

@media only screen and (min-width: 1200px) {
  .sessions-page .carousel {
    min-height: 215px; } }

.alt-venue {
  margin-bottom: 0; }

.p2p-session-row {
  color: #606060 !important; }

.session-page {
  /*Media Section*/ }
  .session-page hr {
    margin-top: 0;
    margin-bottom: 0; }
  .session-page .session-actions {
    padding-top: 1em; }
    .session-page .session-actions button {
      width: 100%;
      border-radius: 5px;
      background-color: #f2f2f2;
      border: 1px solid #c0c0c0;
      color: #4330ff;
      margin-bottom: 0.5em; }
      .session-page .session-actions button.unregister {
        background-color: #4330ff;
        color: #fff; }
      .session-page .session-actions button.unregister-disabled {
        color: #606060;
        background-color: #f2f2f2; }
      .session-page .session-actions button.complete-p2p {
        color: #fff;
        background-color: #fa504b; }
    .session-page .session-actions .active-button {
      background-color: #4330ff;
      color: white; }
    .session-page .session-actions .reg-helper-text {
      text-align: center;
      text-transform: capitalize;
      color: #606060;
      margin-bottom: 0.5em; }
  .session-page .session-schedule {
    color: #909092;
    font-size: 12px; }
  .session-page .blue-header {
    color: #4330ff;
    width: 100%;
    margin-top: 2em;
    display: block; }
  .session-page .user-list {
    padding: 5px 0 5px 0;
    position: relative; }
    .session-page .user-list .user-icons {
      position: absolute;
      right: 0;
      top: 0; }
      .session-page .user-list .user-icons ul li {
        list-style-type: none; }
  .session-page .sponsor-row img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: auto;
    max-width: 225px; }
  .session-page .comment-form-header {
    display: block; }
    .session-page .comment-form-header h4 {
      display: inline-block; }
  .session-page .save-comment {
    float: right;
    color: #4330ff;
    background-color: #f2f2f2;
    border: 1px solid #c0c0c0;
    border-radius: 5px;
    margin: .5em 0;
    padding: 3px 50px 3px 50px;
    display: inline-block; }
    .session-page .save-comment:hover {
      cursor: pointer;
      color: black; }
  .session-page .user-comment {
    color: #909092;
    font-size: 12px;
    white-space: -moz-pre-wrap;
    /* Firefox */
    white-space: -pre-wrap;
    /* ancient Opera */
    white-space: -o-pre-wrap;
    /* newer Opera */
    white-space: pre-wrap;
    /* Chrome; W3C standard */
    word-wrap: break-word;
    /* IE */
    position: relative; }
    .session-page .user-comment hr {
      margin-top: 15px; }
    .session-page .user-comment .time-ago {
      position: absolute;
      margin: .5em;
      top: 0;
      right: 0; }
  .session-page .media-section a {
    color: #000;
    display: block;
    width: 100%;
    float: left; }
    .session-page .media-section a:hover {
      text-decoration: none; }
    .session-page .media-section a ul {
      float: left; }
      .session-page .media-section a ul li {
        border-bottom: none;
        margin: -10px 15px;
        color: #c0c0c0; }
        .session-page .media-section a ul li.attachment-title {
          font-size: 1.1em;
          font-weight: bold;
          color: #000; }
        .session-page .media-section a ul li:hover {
          background: transparent; }
  .session-page .media-section .fa {
    font-size: 2.5em; }
  .session-page .media-section .chevron {
    color: #c0c0c0;
    font-size: .75em; }
  .session-page .media-section ul {
    padding-left: 0px; }
    .session-page .media-section ul li {
      list-style: none;
      border-bottom: 2px solid #eaeaea;
      padding: .5em 0;
      display: block;
      width: 100%;
      float: left; }
      .session-page .media-section ul li:hover {
        background-color: #f2f2f2; }

.note-page .session-schedule:hover {
  cursor: pointer;
  background: #f2f2f2; }

@media only screen and (max-width: 760px) {
  .sessions-page .session-reg {
    width: 60px;
    font-size: 12px; } }

@media only screen and (max-width: 760px) {
  .sessions-page .p2p-reg {
    width: 60px;
    font-size: 12px; } }

.peer-to-peer-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px 2px; }
  .peer-to-peer-container .taken-icon {
    font-size: 22px;
    color: #4330ff;
    margin-right: 20px; }

.peer-to-peer-title {
  font-weight: 600; }

.peer-to-peer-location {
  font-size: 13px;
  font-weight: 400;
  color: gray;
  margin-top: 20px; }

.cancel-button {
  margin-top: 25px;
  border: 0px;
  background-color: #fa504b;
  color: white; }
`, "",{"version":3,"sources":["webpack://./src/components/Sessions/sessions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,eAAe,EAAE;EACjB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY,EAAE;IACd;MACE,WAAW,EAAE;EACjB;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe,EAAE;;AAErB;EACE,yBAAyB,EAAE;EAC3B;IACE,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,cAAc,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,YAAY;EACZ,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,WAAW,EAAE;EACb;IACE,gBAAgB;IAChB,iBAAiB,EAAE;IACnB;MACE,WAAW,EAAE;IACf;MACE,cAAc,EAAE;MAChB;QACE,cAAc,EAAE;MAClB;QACE,WAAW,EAAE;;AAErB;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB,EAAE;;AAE3B;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB,EAAE;;AAEvB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B,EAAE;EAC/B;IACE,wBAAwB;IACxB,kBAAkB,EAAE;;AAExB;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iDAAiD;EACjD,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,sEAAsE;EACtE,qBAAqB;EACrB,uCAAuC;EACvC,sBAAsB;EACtB,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe,EAAE;;AAEnB;EACE,aAAa,EAAE;EACf;IACE,cAAc,EAAE;EAClB;IACE,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;EACE,YAAY,EAAE;;AAEhB;EACE;IACE,gBAAgB,EAAE,EAAE;;AAExB;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE;IACE,iBAAiB,EAAE,EAAE;;AAEzB;EACE,gBAAgB,EAAE;;AAEpB;EACE,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB,EAAE;EAClB;IACE,aAAa;IACb,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;IAClB;MACE,WAAW;MACX,kBAAkB;MAClB,yBAAyB;MACzB,yBAAyB;MACzB,cAAc;MACd,oBAAoB,EAAE;MACtB;QACE,yBAAyB;QACzB,WAAW,EAAE;MACf;QACE,cAAc;QACd,yBAAyB,EAAE;MAC7B;QACE,WAAW;QACX,yBAAyB,EAAE;IAC/B;MACE,yBAAyB;MACzB,YAAY,EAAE;IAChB;MACE,kBAAkB;MAClB,0BAA0B;MAC1B,cAAc;MACd,oBAAoB,EAAE;EAC1B;IACE,cAAc;IACd,eAAe,EAAE;EACnB;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc,EAAE;EAClB;IACE,oBAAoB;IACpB,kBAAkB,EAAE;IACpB;MACE,kBAAkB;MAClB,QAAQ;MACR,MAAM,EAAE;MACR;QACE,qBAAqB,EAAE;EAC7B;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,cAAc,EAAE;IAChB;MACE,qBAAqB,EAAE;EAC3B;IACE,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,0BAA0B;IAC1B,qBAAqB,EAAE;IACvB;MACE,eAAe;MACf,YAAY,EAAE;EAClB;IACE,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,OAAO;IACP,kBAAkB,EAAE;IACpB;MACE,gBAAgB,EAAE;IACpB;MACE,kBAAkB;MAClB,YAAY;MACZ,MAAM;MACN,QAAQ,EAAE;EACd;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW,EAAE;IACb;MACE,qBAAqB,EAAE;IACzB;MACE,WAAW,EAAE;MACb;QACE,mBAAmB;QACnB,kBAAkB;QAClB,cAAc,EAAE;QAChB;UACE,gBAAgB;UAChB,iBAAiB;UACjB,WAAW,EAAE;QACf;UACE,uBAAuB,EAAE;EACjC;IACE,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;IACnB;MACE,gBAAgB;MAChB,gCAAgC;MAChC,eAAe;MACf,cAAc;MACd,WAAW;MACX,WAAW,EAAE;MACb;QACE,yBAAyB,EAAE;;AAEnC;EACE,eAAe;EACf,mBAAmB,EAAE;;AAEvB;EACE;IACE,WAAW;IACX,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,WAAW;IACX,eAAe,EAAE,EAAE;;AAEvB;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,cAAc;IACd,kBAAkB,EAAE;;AAExB;EACE,gBAAgB,EAAE;;AAEpB;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,YAAY,EAAE","sourcesContent":[".sessions-page .filter-bar {\n  display: flex;\n  justify-content: space-between;\n  background-color: #002856;\n  width: 100%;\n  min-height: 2em; }\n  .sessions-page .filter-bar .schedule-filter {\n    display: flex;\n    align-items: center;\n    color: white; }\n    .sessions-page .filter-bar .schedule-filter label {\n      margin: 5px; }\n  .sessions-page .filter-bar .custom-filter {\n    display: flex;\n    align-items: center;\n    color: white;\n    margin: 5px;\n    cursor: pointer; }\n\n.sessions-page .session-link {\n  width: calc(100% - 100px); }\n  .sessions-page .session-link:hover {\n    text-decoration: none; }\n\n.sessions-page .session-icons {\n  margin: .5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #606060; }\n  .sessions-page .session-icons ul li {\n    list-style-type: none; }\n\n.sessions-page .session {\n  color: black;\n  border: 0.5px solid #eaeaea;\n  line-height: 10px;\n  text-decoration: none;\n  position: relative; }\n\n.sessions-page .session:not(.no-hover):hover {\n  background: #d4e4e9; }\n\n.sessions-page .session-time {\n  background: #909092;\n  color: white;\n  padding: 10px; }\n\n.sessions-page .session-reg {\n  text-align: center;\n  width: 90px; }\n  .sessions-page .session-reg .fa {\n    margin-top: .1em;\n    font-size: 2.25em; }\n    .sessions-page .session-reg .fa.fa-plus-circle {\n      color: gray; }\n    .sessions-page .session-reg .fa.fa-check-circle {\n      color: #4330ff; }\n      .sessions-page .session-reg .fa.fa-check-circle.yellow {\n        color: #feb52b; }\n      .sessions-page .session-reg .fa.fa-check-circle.grey {\n        color: grey; }\n\n.sessions-page .p2p-reg {\n  color: gray;\n  border: 0px solid #eaeaea;\n  text-align: center;\n  width: 90px;\n  line-height: 1.2;\n  padding-top: 10px;\n  background-color: white; }\n\n.sessions-page .track-color {\n  display: inline;\n  padding: 1px;\n  float: left;\n  width: .25em;\n  min-height: 4.5em;\n  margin-right: .35em; }\n\n.sessions-page .session-reg {\n  border: 0.5px solid #eaeaea;\n  border-right: none;\n  background: #f2f2f2;\n  padding-right: 0px !important; }\n  .sessions-page .session-reg p {\n    margin: 5px 0px 0px -3px;\n    text-align: center; }\n\n.sessions-page .session-name {\n  padding-top: 10px;\n  color: black;\n  line-height: 1em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block; }\n\n.sessions-page .session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px; }\n\n.sessions-page .session.itinerary {\n  padding: 20px; }\n  .sessions-page .session.itinerary .session-name {\n    color: #909092; }\n  .sessions-page .session.itinerary:hover {\n    cursor: default;\n    background: none; }\n\n.sessions-page .blue {\n  color: #4330ff; }\n\n.sessions-page .carousel {\n  min-height: 67px; }\n\n.sessions-page .disabled {\n  opacity: 0.3; }\n\n@media only screen and (min-width: 575px) {\n  .sessions-page .carousel {\n    min-height: 99px; } }\n\n@media only screen and (min-width: 767px) {\n  .sessions-page .carousel {\n    min-height: 134px; } }\n\n@media only screen and (min-width: 991px) {\n  .sessions-page .carousel {\n    min-height: 181px; } }\n\n@media only screen and (min-width: 1200px) {\n  .sessions-page .carousel {\n    min-height: 215px; } }\n\n.alt-venue {\n  margin-bottom: 0; }\n\n.p2p-session-row {\n  color: #606060 !important; }\n\n.session-page {\n  /*Media Section*/ }\n  .session-page hr {\n    margin-top: 0;\n    margin-bottom: 0; }\n  .session-page .session-actions {\n    padding-top: 1em; }\n    .session-page .session-actions button {\n      width: 100%;\n      border-radius: 5px;\n      background-color: #f2f2f2;\n      border: 1px solid #c0c0c0;\n      color: #4330ff;\n      margin-bottom: 0.5em; }\n      .session-page .session-actions button.unregister {\n        background-color: #4330ff;\n        color: #fff; }\n      .session-page .session-actions button.unregister-disabled {\n        color: #606060;\n        background-color: #f2f2f2; }\n      .session-page .session-actions button.complete-p2p {\n        color: #fff;\n        background-color: #fa504b; }\n    .session-page .session-actions .active-button {\n      background-color: #4330ff;\n      color: white; }\n    .session-page .session-actions .reg-helper-text {\n      text-align: center;\n      text-transform: capitalize;\n      color: #606060;\n      margin-bottom: 0.5em; }\n  .session-page .session-schedule {\n    color: #909092;\n    font-size: 12px; }\n  .session-page .blue-header {\n    color: #4330ff;\n    width: 100%;\n    margin-top: 2em;\n    display: block; }\n  .session-page .user-list {\n    padding: 5px 0 5px 0;\n    position: relative; }\n    .session-page .user-list .user-icons {\n      position: absolute;\n      right: 0;\n      top: 0; }\n      .session-page .user-list .user-icons ul li {\n        list-style-type: none; }\n  .session-page .sponsor-row img {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    height: auto;\n    max-width: 225px; }\n  .session-page .comment-form-header {\n    display: block; }\n    .session-page .comment-form-header h4 {\n      display: inline-block; }\n  .session-page .save-comment {\n    float: right;\n    color: #4330ff;\n    background-color: #f2f2f2;\n    border: 1px solid #c0c0c0;\n    border-radius: 5px;\n    margin: .5em 0;\n    padding: 3px 50px 3px 50px;\n    display: inline-block; }\n    .session-page .save-comment:hover {\n      cursor: pointer;\n      color: black; }\n  .session-page .user-comment {\n    color: #909092;\n    font-size: 12px;\n    white-space: -moz-pre-wrap;\n    /* Firefox */\n    white-space: -pre-wrap;\n    /* ancient Opera */\n    white-space: -o-pre-wrap;\n    /* newer Opera */\n    white-space: pre-wrap;\n    /* Chrome; W3C standard */\n    word-wrap: break-word;\n    /* IE */\n    position: relative; }\n    .session-page .user-comment hr {\n      margin-top: 15px; }\n    .session-page .user-comment .time-ago {\n      position: absolute;\n      margin: .5em;\n      top: 0;\n      right: 0; }\n  .session-page .media-section a {\n    color: #000;\n    display: block;\n    width: 100%;\n    float: left; }\n    .session-page .media-section a:hover {\n      text-decoration: none; }\n    .session-page .media-section a ul {\n      float: left; }\n      .session-page .media-section a ul li {\n        border-bottom: none;\n        margin: -10px 15px;\n        color: #c0c0c0; }\n        .session-page .media-section a ul li.attachment-title {\n          font-size: 1.1em;\n          font-weight: bold;\n          color: #000; }\n        .session-page .media-section a ul li:hover {\n          background: transparent; }\n  .session-page .media-section .fa {\n    font-size: 2.5em; }\n  .session-page .media-section .chevron {\n    color: #c0c0c0;\n    font-size: .75em; }\n  .session-page .media-section ul {\n    padding-left: 0px; }\n    .session-page .media-section ul li {\n      list-style: none;\n      border-bottom: 2px solid #eaeaea;\n      padding: .5em 0;\n      display: block;\n      width: 100%;\n      float: left; }\n      .session-page .media-section ul li:hover {\n        background-color: #f2f2f2; }\n\n.note-page .session-schedule:hover {\n  cursor: pointer;\n  background: #f2f2f2; }\n\n@media only screen and (max-width: 760px) {\n  .sessions-page .session-reg {\n    width: 60px;\n    font-size: 12px; } }\n\n@media only screen and (max-width: 760px) {\n  .sessions-page .p2p-reg {\n    width: 60px;\n    font-size: 12px; } }\n\n.peer-to-peer-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 2px; }\n  .peer-to-peer-container .taken-icon {\n    font-size: 22px;\n    color: #4330ff;\n    margin-right: 20px; }\n\n.peer-to-peer-title {\n  font-weight: 600; }\n\n.peer-to-peer-location {\n  font-size: 13px;\n  font-weight: 400;\n  color: gray;\n  margin-top: 20px; }\n\n.cancel-button {\n  margin-top: 25px;\n  border: 0px;\n  background-color: #fa504b;\n  color: white; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
